<div class="image-container">
  <div (click)="moveImage(-1)">
    <img src="assets/previous-icon.svg" class="previous-arrow" alt="previous">
  </div>
  <div (click)="moveImage(+1)">
    <img src="assets/next-icon.svg" class="next-arrow " alt="next">
  </div>
  <img (error)="setDefaultPlaceholder()" src="{{activeImage}}"
       class="product-image" alt="Product">
  <div class="indicator">
    <div *ngFor="let image of images; index as i"
         class="dot"
         (click)="showImage(i)"
         [style.background-color]="getColor(i)">
    </div>
  </div>
</div>
